export const getQueryParams = (): Partial<Record<string, string>> => {
  return Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  )
}
